import PropTypes from 'prop-types';
import { css } from '@emotion/react';

import { colors } from 'styles/theme';

import Text from '../Text/Text';
import Link from '../Link/Link';
import ArrowRightIcon from '../icons/ArrowRightIcon';
import { ctaBaseCss } from '../PromoCards/PromoCards.style';

const linkCss = css`
  display: inline-flex;
  align-items: center;
`;

function PromoCardsCta({ text, linkAs, linkHref, className }) {
  return (
    <div css={ctaBaseCss} className={className}>
      <Link href={linkHref} as={linkAs}>
        <Text fontWeight={500} color={colors.darkPurple} css={linkCss}>
          {text ?? 'Learn more'} <ArrowRightIcon />
        </Text>
      </Link>
    </div>
  );
}

PromoCardsCta.propTypes = {
  linkAs: PropTypes.string,
  linkHref: PropTypes.string.isRequired,
  text: PropTypes.string,
  className: PropTypes.string,
};

export default PromoCardsCta;
